import axios from 'axios';
import { AssistQueryClient } from 'services/assist-api/query-client';

export const postLogout = async (
  token: string | null,
  refreshToken: string | null
): Promise<void> => {
  await axios.post(`${BACKEND_URL}/tokens/revoke`, { token, refresh_token: refreshToken });
  AssistQueryClient.clear();
};
